import {ActionBase, ActionWithPayload} from '../../../../helpers/reduxHelpers';
import {CallApiFailedAction} from '../../../api/apiActions';
import {AnalyticsSavedView, AnalyticsSelectedViewId} from './analyticsPanelViewsState';

// Note: These types are here rather than in the actions file itself in order
// to fix a circular dependency issue.

/*
 * Type enum.
 */

export enum AnalyticsPanelViewsActionsEnum {
  TOGGLE_VIEW_VISIBILITY = '@@panels/analytics/views/TOGGLE_VIEW_VISIBILITY',
  ADD_TEMPORARY_VIEW = '@@panels/analytics/ADD_TEMPORARY_VIEW',
  REMOVE_TEMPORARY_VIEW = '@@panels/analytics/REMOVE_TEMPORARY_VIEW',
  FETCH_SAVED_VIEWS = '@@panels/analytics/views/FETCH_SAVED_VIEWS',
  FETCH_SAVED_VIEWS_COMPLETED = '@@panels/analytics/views/FETCH_SAVED_VIEWS_COMPLETED',
  FETCH_SAVED_VIEWS_FAILED = '@@panels/analytics/views/FETCH_SAVED_VIEWS_FAILED',
  CREATE_SAVED_VIEW = '@@panels/analytics/views/CREATE_SAVED_VIEW',
  CREATE_SAVED_VIEW_FAILED = '@@panels/analytics/views/CREATE_SAVED_VIEW_FAILED',
  UPDATE_SAVED_VIEW = '@@panels/analytics/views/UPDATE_SAVED_VIEW',
  DELETE_SAVED_VIEW = '@@panels/analytics/views/DELETE_SAVED_VIEW',
  CLEAN_ERROR = '@@panels/analytics/views/CLEAN_ERROR',
}

/*
 * Types.
 */

export interface ToggleViewVisibilityAction extends ActionWithPayload<AnalyticsSelectedViewId> {
  type: AnalyticsPanelViewsActionsEnum.TOGGLE_VIEW_VISIBILITY;
}

export interface AddTemporaryViewAction extends ActionWithPayload<ReadonlyArray<AnalyticsSavedView>> {
  type: AnalyticsPanelViewsActionsEnum.ADD_TEMPORARY_VIEW;
}

export interface RemoveTemporaryViewAction extends ActionWithPayload<AnalyticsSelectedViewId> {
  type: AnalyticsPanelViewsActionsEnum.REMOVE_TEMPORARY_VIEW;
}

export interface FetchSavedViewsAction extends ActionBase {
  type: AnalyticsPanelViewsActionsEnum.FETCH_SAVED_VIEWS;
}

export interface FetchSavedViewsCompletedAction extends ActionWithPayload<ReadonlyArray<AnalyticsSavedView>> {
  type: AnalyticsPanelViewsActionsEnum.FETCH_SAVED_VIEWS_COMPLETED;
}

export interface FetchSavedViewsFailedAction extends CallApiFailedAction<{}> {
  type: AnalyticsPanelViewsActionsEnum.FETCH_SAVED_VIEWS_FAILED;
}

type CreateSavedViewActionPayload = Omit<AnalyticsSavedView, 'id' | 'isDisplayed' | 'metadata'>;

export interface CreateSavedViewAction extends ActionWithPayload<CreateSavedViewActionPayload> {
  type: AnalyticsPanelViewsActionsEnum.CREATE_SAVED_VIEW;
}

export interface CreateSavedViewFailedAction extends ActionWithPayload<number> {
  type: AnalyticsPanelViewsActionsEnum.CREATE_SAVED_VIEW_FAILED;
}

type UpdateSavedViewActionPayload = AnalyticsSavedView;

export interface UpdateSavedViewAction extends ActionWithPayload<UpdateSavedViewActionPayload> {
  type: AnalyticsPanelViewsActionsEnum.UPDATE_SAVED_VIEW;
}

export interface DeleteSavedViewAction extends ActionWithPayload<AnalyticsSelectedViewId> {
  type: AnalyticsPanelViewsActionsEnum.DELETE_SAVED_VIEW;
}

export interface CleanErrorViewAction extends ActionBase {
  type: AnalyticsPanelViewsActionsEnum.CLEAN_ERROR;
}

/*
 * Union type.
 */

type FetchSavedViewsActions =
  | FetchSavedViewsAction
  | FetchSavedViewsCompletedAction
  | FetchSavedViewsFailedAction;

export type AnalyticsPanelViewsAction =
  | ToggleViewVisibilityAction
  | FetchSavedViewsActions
  | AddTemporaryViewAction
  | RemoveTemporaryViewAction
  | CreateSavedViewAction
  | CreateSavedViewFailedAction
  | UpdateSavedViewAction
  | DeleteSavedViewAction
  | CleanErrorViewAction;
